import { Breadcrumb, BreadcrumbHint, replayIntegration } from '@sentry/browser'
import { REACT_APP_ENV } from 'constants/envs'
import * as Sentry from '@sentry/browser'
import { IGNORED_ENDPOINTS_AND_STATUSES } from 'constants/sentry-ignored-endpoints'

export class SentryConfig {
  sessionReplay() {
    if (REACT_APP_ENV !== 'prd') return {}

    return {
      integrations: [
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      minReplayDuration: 10000,
    }
  }

  beforeBreadcrumb(breadcrumb: Breadcrumb, hint?: BreadcrumbHint) {
    if (breadcrumb.category === 'ui.click') {
      const event = hint?.event as MouseEvent
      const target = event.target as HTMLElement
      const message =
        target.innerText || target.ariaLabel || target.parentElement?.ariaLabel

      return {
        ...breadcrumb,
        message,
        data: {
          message,
          element: breadcrumb.message,
          url: target.baseURI,
        },
      }
    }

    return breadcrumb
  }

  shouldCaptureRequestError(status: number, url: string): boolean {
    const ignoredEndpoint = IGNORED_ENDPOINTS_AND_STATUSES.find(
      ({ endpoint }) => endpoint.test(url)
    )

    if (ignoredEndpoint) {
      return !ignoredEndpoint.statuses.includes(status)
    }

    return true
  }

  captureRequestError(res: any) {
    const { method, url, data } = res.config || { method: '', url: '' }
    const status = res.status || res.response?.status
    const error = new Error(`(${url}) ${res.message}`)
    error.name = `Request Failed ${url}`

    Sentry.captureException(error, {
      extra: {
        type: method,
        status: status,
        url: res.request?.responseURL || url,
        path: window.location.href,
        payload: data,
        response: JSON.stringify(res.response?.data),
        message: res.message,
        name: res.name,
      },
    })
  }
}
